import { useState } from "react";
import { IconExternalLink, IconFileDescription } from "@tabler/icons-react";
import { Button } from "../../../../components/common/button";
import { Heading, Text } from "../../../../components/common/typography";
import { DatasheetPreviewModal } from "./datasheet-preview-modal";

interface Props {
  /** Template id used to fetch the signed download URL when a PDF is present. */
  productTemplateId?: number | null;
  /** True when the seller uploaded a real PDF (vs. just an external URL). */
  hasDatasheetPdf?: boolean | null;
  /** Legacy external URL (e.g. bulk-import fallback). Used only when no PDF. */
  externalDatasheetUrl?: string | null;
}

export function DatasheetSection({
  productTemplateId,
  hasDatasheetPdf,
  externalDatasheetUrl,
}: Props) {
  const [open, setOpen] = useState(false);

  if (hasDatasheetPdf && productTemplateId) {
    return (
      <>
        <div className="pt-4 border-t border-uiSecondary">
          <Heading variant="h3" tone="dark" className="mb-3">
            Datasheet
          </Heading>
          <div className="flex items-center gap-3">
            <IconFileDescription size={32} className="text-textBody" />
            <div className="min-w-0 flex-1">
              <Text variant="body" tone="body">
                Manufacturer datasheet (PDF) — opens in an in-page preview.
              </Text>
            </div>
            <Button variant="secondary" size="sm" onClick={() => setOpen(true)}>
              View datasheet
            </Button>
          </div>
        </div>
        {open ? (
          <DatasheetPreviewModal
            productTemplateId={productTemplateId}
            onClose={() => setOpen(false)}
          />
        ) : null}
      </>
    );
  }

  if (externalDatasheetUrl) {
    return (
      <div className="pt-4 border-t border-uiSecondary">
        <Heading variant="h3" tone="dark" className="mb-3">
          Datasheet
        </Heading>
        <a
          href={externalDatasheetUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-primary underline break-all"
        >
          <IconExternalLink size={18} />
          {externalDatasheetUrl}
        </a>
      </div>
    );
  }

  return null;
}
